import {
  type ICurrentUserInfoResponse,
  type ISaveAreTipsHiddenRequest,
  type ISaveCurrentUserInfoRequest,
  type ISaveIsMachineBarPinnedRequest,
  type ISaveIsStartBannerHiddenRequest,
  type ISaveLanguageCodeRequest,
  type ISaveThemeRequest,
  type ISaveTimezoneRequest
} from '@libs/models';

import { BaseApi, type Result } from './api-client';

export class UsersApi extends BaseApi {
  protected readonly baseUrl = '/api/users';

  async getCurrentUser(): Promise<Result<ICurrentUserInfoResponse>> {
    return this.get<ICurrentUserInfoResponse>('/current', null, 'Get user failed');
  }

  async saveCurrentUserInfo(request: ISaveCurrentUserInfoRequest): Promise<void> {
    return this.patchVoid('/current', request);
  }

  async saveTheme(request: ISaveThemeRequest): Promise<void> {
    return this.patchVoid('/current/theme', request);
  }

  async saveLanguageCode(request: ISaveLanguageCodeRequest): Promise<void> {
    return this.patchVoid('/current/language-code', request);
  }

  async saveTimezone(request: ISaveTimezoneRequest): Promise<void> {
    return this.patchVoid('/current/timezone', request);
  }

  async saveAreTipsHidden(request: ISaveAreTipsHiddenRequest): Promise<void> {
    return this.patchVoid('/current/tips-hidden', request);
  }

  async saveIsMachineBarPinned(request: ISaveIsMachineBarPinnedRequest): Promise<void> {
    return this.patchVoid('/current/machine-bar-pinned', request);
  }

  async saveIsStartBannerHidden(request: ISaveIsStartBannerHiddenRequest): Promise<void> {
    return this.patchVoid('/current/start-banner-hidden', request);
  }
}
